
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { NationalityApi } from '../../../shared/nestjs/gd-only/services/nationality.api';
import { RequestAddNationalityDto, RequestUpdateNationalityDto, RequestDeleteNationalityDto } from '../../../shared/nestjs/gd-only/dto/nationality.dto';
import { RequestPaging } from '../../../shared/nestjs/gd-all-in-one/dto/claim.dto';
import { ResponsePaging } from '../../../shared/nestjs/nest-responses';

/*
  Generated class for the ChangePrivacyBloc provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class NationalityBloc {
  private subscriptions: Array<Subscription> = [];
  constructor(
    public nationalityApi: NationalityApi
  ) {

  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  listNationality(payload: RequestPaging) {
    return new Promise<ResponsePaging<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.nationalityApi.listNationality(payload)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  addNationality(payload: RequestAddNationalityDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.nationalityApi.addNationality(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  updateNationality(payload: RequestUpdateNationalityDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.nationalityApi.updateNationality(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  deleteNationality(payload: RequestDeleteNationalityDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.nationalityApi.deleteNationality(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }
}




// WEBPACK FOOTER //
// ./src/bloc/settings/employee-setup/nationality.bloc.ts